import React from "react";
import { Link } from "react-router-dom";
import "./BackBtn.css";
const BackBtn = () => {
  return (
    <div>
      <div className="bck_btn">
        <Link to="/service">
          <p>
            <i class="fas fa-backward"></i>Back to Services
          </p>
        </Link>
      </div>
    </div>
  );
};

export default BackBtn;
